import './App.scss';
import './translationfix.scss';
import cssVar from './index.scss'
import React, { useState, useEffect, useContext } from 'react';
import { useGlobalContext } from './helper/DataMain';

import Menu from './components/Menu/Menu';
import FooterControl from './components/FooterControls/FooterControls';
import HowToUse from './components/HowToUse/HowToUse';
import Arbutton from './components/Menu/Arbutton';
import GlobalDisclaimer from './components/GlobalUtils/GlobalDisclaimer';




function App() {
  const { jsonData } = useGlobalContext() || {};
  let { QRSupport, LangugageTranslation, accordianClick, productId, onLoadActiveradioButton, onLoadActiveAccordionMobile, imageSequence, video, dimensions, skipInNextPrevious, includeAccordionInNextPrevious} = {...jsonData};
  window.config.imageSequenceStatus = (typeof imageSequence == 'boolean') ? imageSequence : false; //store image sequence flag @DS
  window.config.videoStatus = (typeof video == 'boolean') ? video : false; //store video flag @DS
  window.config.dimensions = (typeof dimensions == 'boolean') ? dimensions : false; //store dimensions flag @YK
  window.config.skipInNextPrevious = skipInNextPrevious; //store skip menu's in config @DS
  window.config.includeAccordionInNextPrevious = includeAccordionInNextPrevious; //store skip menu's in config @DS
  let allLangugages = Object.keys(jsonData.menus);
  const [isFirstAccordion, setIsFirstAccordion] = useState(false);

  const getUrlParams = (params) => {
    var url = new URL(window.location.href);
    // url = url.href;
    // console.log('url ', url)
    var paramsValue = url.searchParams.get(params);
    if(paramsValue == null || !LangugageTranslation || !allLangugages.includes(paramsValue.toUpperCase())) paramsValue = 'en';
    // console.log('paramsValue ', paramsValue);
    return paramsValue
  }
  
  // console.log('jsonData ', jsonData);
  
  let langCode = getUrlParams("locale").toLocaleUpperCase();
  
  const menuData = jsonData.menus[langCode];
  let menuSubmenu = menuData.filter(val => val.menuVisibility !== 'hide');
  let { ui } = menuSubmenu.shift();
  
  /*Add langCode as class in body*/
  let bodyTag = document.getElementsByTagName("BODY")[0]; 
  bodyTag.classList.add(langCode.toLowerCase()); 
  /*Add langCode as class in body end*/
  let cssVariableValues = {...cssVar};
  /*Get :root styles end */

  window.isMobIsipadIsPotrait = window.deviceBasedonBodyClass == 'ipadDesktopPortrait' || window.deviceBasedonBodyClass == 'mobilePortrait' || window.deviceBasedonBodyClass =='ipadPortrait'  || window.deviceBasedonBodyClass =='androidTabPortrait';;
  window.isipadLandscap = window.deviceBasedonBodyClass == 'ipadLandscape' || window.deviceBasedonBodyClass == 'ipadDesktopLandscape';
  window.androidTabLandscape = window.deviceBasedonBodyClass == 'androidTabLandscape';
  
  // console.log('menuSubmenu ', menuSubmenu)
  // const [menuJsonData, setMenuJsonData] = useState([]);
  // console.log('jsonData ', jsonDatar);
  
  let jsonDataKeys = [];
  if(jsonData !== undefined && jsonData.length == undefined){
    jsonDataKeys = Object.keys(jsonData);
    // console.log('jsonDataKeys ', jsonDataKeys.length);
  }
  
  const getDOMElementsForTranslation = (ui) =>{
    // console.log('data ', data)
    let moveText = document.querySelector('#move_text');
    let rotateText = document.querySelector('#rotate_text');
    let zoomText = document.querySelector('#zoom_text');
    let exploreButtton = document.querySelector('#exploreButtton');
    let dummyFocus = document.querySelector('#dummyFocus');
    moveText.innerHTML = ui.move;
    rotateText.innerHTML = ui.rotate;
    zoomText.innerHTML = ui.zoom;
    exploreButtton.innerHTML = ui.exploreProductIn3D;
    // dummyFocus.ariaLabel = ProjectTitle+' Real Time Viewer';
    // console.log('window.uiObj ', window.UiUtils.updateAriaLabel)
    // alert(ui.ProjectTitle)
    window.UiUtils.updateAriaLabel('getDOMElementsForTranslation', dummyFocus, ui.projectTitle);

    // console.log(moveText.innerHTML)
  }

  
  if(jsonDataKeys.length != 0){
    
    // console.log('langCode ', langCode)
    // {ProjectTitle, QRSupport, LangugageTranslation, accordianClick, productId} = {...jsonData}
    
    // console.log('menuData ', menuData);
    getDOMElementsForTranslation(ui);
    document.title = ui.projectTitle;
    window.ProjectTitle = ui.projectTitle;
    // setMenuJsonData(menuData);
    // console.log('menuJsonData ', menuJsonData)
  }

    
    const [count, setCount] = useState(0);
    window.shouldReRenderMenu = true;
    window.reRenderMenu = () => {
      setCount(count + 1);
      setIsFirstAccordion(false); // Resetting isFirstAccordion to false on re-render
    }

    useEffect(() => {
      // Perform your action here
      // console.log("App Component has loaded");
      setTimeout(window.UiUtils.getDOMElementsinObject, 1000)
      // window.getDOMElementsinObject();
    }, []); // Empty dependency array

    //   useEffect(() => {
    //     console.log('useEffect menuJsonData productTypeList ', jsonData);
        
    //     // reRenderMenu();
    // }, [jsonData])

    /*MENU */
     const accordionMenu = (data, id, location) => {
        // console.log('accordionMenu clicked ', data, id);
        // console.log('accordionMenu window.selectedConfig ', window.selectedConfig);
        window.clearCalloutCanvas();
        let previousSelectedAccordionMenu = document.querySelector('.accordionMenu.active');
        
        // if(!isMobIsipadIsPotrait && previousSelectedAccordionMenu && previousSelectedAccordionMenu.id === id) {
          if(previousSelectedAccordionMenu) {

            /*Code added to remove submenu active class when we close accordion */
            let previousSelectedAccordionMenuType = previousSelectedAccordionMenu.id.split('accordion_')[1];
            var accordionContentPreviousSelectedAccordionMenu = document.getElementById(id).nextSibling.firstChild;
            let activeSubmenuPreviousSelectedAccordionMenu = accordionContentPreviousSelectedAccordionMenu.querySelector('.subMenuBtn.active');
            if(activeSubmenuPreviousSelectedAccordionMenu && !activeSubmenuPreviousSelectedAccordionMenu.classList.contains("radioButton") && !activeSubmenuPreviousSelectedAccordionMenu.classList.contains("colorView")) activeSubmenuPreviousSelectedAccordionMenu.classList.remove('active');
            /*Code added to remove submenu active class when we close accordion */
            
            previousSelectedAccordionMenu.classList.remove('active');
            previousSelectedAccordionMenu.setAttribute('aria-expanded', 'false');
            window.calloutObj = null; // to hide the hotspot numbers on accordion click 
          }
        // } 
        let isAccordion = document.querySelector(`#${id}`) !== null;
        let isPreviousSelectedAccordionMenu = previousSelectedAccordionMenu !== null;
        // console.log(' document.querySelector(`#${id}`) ',  isAccordion)
        // console.log(' previousSelectedAccordionMenu ',  previousSelectedAccordionMenu)
        if(!isPreviousSelectedAccordionMenu && isAccordion) {
            document.querySelector(`#${id}`).classList.add('active');
            document.querySelector(`#${id}`).setAttribute('aria-expanded', 'true');
        } else if((isPreviousSelectedAccordionMenu && previousSelectedAccordionMenu.id !== id) && isAccordion){
            document.querySelector(`#${id}`).classList.add('active');
            document.querySelector(`#${id}`).setAttribute('aria-expanded', 'true');
        }
        // if(previousSelectedAccordionMenu && previousSelectedAccordionMenu.id !== id && isAccordion) document.querySelector(`#${id}`).classList.add('active');

        /*For Menu Height calculation in order to set height so CSS transition should work on menu expand/collaps*/
          /* var accordionContentAll = document.querySelectorAll('.accordionContent');
          if(!window.isMobIsipadIsPotrait) {
            for (var i = 0; i <= accordionContentAll.length - 1; i++) {
                accordionContentAll[i].style.height = '0px'; //With this line we colaps accordion menu 
            }
          
            var accordionContent = document.getElementById(id).nextSibling.firstChild;
            if(!isPreviousSelectedAccordionMenu && isAccordion) {
              document.querySelector(`#${id}`).nextSibling.style.height = accordionContent.offsetHeight + 'px'; //With this line we exapnd accordion menu 
            } else if((isPreviousSelectedAccordionMenu && previousSelectedAccordionMenu.id !== id) && isAccordion){
                document.querySelector(`#${id}`).nextSibling.style.height = accordionContent.offsetHeight + 'px'; //With this line we exapnd accordion menu 
            }
          } */
         manageAccordionContentHeight(id, isPreviousSelectedAccordionMenu, isAccordion, previousSelectedAccordionMenu);
        /*For Menu Height calculation in order to set height so CSS transition should work on menu expand/collaps end*/
        // console.log('data ', data)
        if(data.sequenceName && data.sequenceName !== "") window.selectedConfig['currentSelectedItem'] = data.id; // to keep track of current selected item in next previous functionality, this is required when we have multiple accordion and submenu and user has not selected any submenu from 2nd accordion and clicks next/previous then in that case it should select first submenu of that accordion
        /*Globale scoped function call that handles UI elements for desktop like hide how to use popup*/
        window.UiUtils.handleUIwithMenuClick(data);
        window.UiUtils.handle3DwithMenuClick(data, 'menu');
        if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateTabindex('accordionMenu', id);
        if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateAriaHidden('accordionMenu', id);

     }

     const manageAccordionContentHeight = (id, isPreviousSelectedAccordionMenu, isAccordion, previousSelectedAccordionMenu) => {

      /*For Menu Height calculation in order to set height so CSS transition should work on menu expand/collaps*/
          var accordionContentAll = document.querySelectorAll('.accordionContent');
          if(!window.selectedConfig['selectedAccordion'] || window.selectedConfig['selectedAccordion'].length > 0) window.selectedConfig['selectedAccordion'] = [];
          if(!window.isMobIsipadIsPotrait) {
            for (var i = 0; i <= accordionContentAll.length - 1; i++) {
                accordionContentAll[i].style.height = '0px'; /*With this line we colaps accordion menu */
            }
          
            var accordionContent = document.getElementById(id).nextSibling.firstChild;
            // console.log('accordionContent ', accordionContent)
            if(!isPreviousSelectedAccordionMenu && isAccordion) {
              document.querySelector(`#${id}`).nextSibling.style.height = accordionContent.offsetHeight + 'px'; /*With this line we exapnd accordion menu */
            } else if((isPreviousSelectedAccordionMenu && previousSelectedAccordionMenu.id !== id) && isAccordion){
                document.querySelector(`#${id}`).nextSibling.style.height = accordionContent.offsetHeight + 'px'; /*With this line we exapnd accordion menu */
            }
            if(document.querySelector(`#${id}`).nextSibling.style.height !== '0px') {
              
              if(!window.selectedConfig['selectedAccordion'].includes(id)) {  
                window.selectedConfig['selectedAccordion'].push(id); // this line is used to keep track of selected accordion menu so that we can expand it on next/previous click
              }
            }
            
            // if(previousSelectedAccordionMenu && previousSelectedAccordionMenu.id !== id) document.getElementById(id).nextSibling.style.height = accordionContent.offsetHeight + 'px'; /*With this line we exapnd accordion menu */
          }
          else {
              // for mobile we are not use height, here is the block for selectedaccordion
             
              if (!window.selectedConfig['selectedAccordion'].includes(id)) {
                  window.selectedConfig['selectedAccordion'] = [id];
                  // console.log("(mobile)window.selectedConfig['selectedAccordion']", window.selectedConfig['selectedAccordion']);
              }
          }
        /*For Menu Height calculation in order to set height so CSS transition should work on menu expand/collaps end*/
        
     }

    //  let isFirstAccordion = false; // this variable is used to check if first accordion is active or not, used in next/previous functionality
     const handleSubMenuClick = (data, id, nextPreviousHandler, resetHandler) => {
      // console.log('Submenu clicked ', data);
        // window.clearCalloutCanvas(); // @YK commented, seems we have this line duplicate 
        window.calloutObj = []; // added this line in-order to prevent rendering of previous menu hotspot number so when user clicks any submenu the calloutobj array will be empty and respective content will get pushed in this array in UiUtils.handleHotspotwithMenuClick() and will display hotspot numbers
        window.clearCalloutCanvas();
        
        let currentSelectedSubMenu = document.querySelector(`#menu_id_${data.id}`);
        let currentSelectedSubMenuAlreadyActive = currentSelectedSubMenu.classList.contains('active');
        // console.log('currentSelectedSubMenu ', currentSelectedSubMenuAlreadyActive);
        if(window.isMobIsipadIsPotrait){
            window.selectedConfig.drawHotspotCircleMobile = !currentSelectedSubMenu.classList.contains('active'); // this line makes drawHotspotCircle true/false for mobile as on mobile submenu is accordion 
          }
        let isradioButton = currentSelectedSubMenu ? currentSelectedSubMenu.classList.contains('radioButton') : null;
        const closestsubMenu = currentSelectedSubMenu ? currentSelectedSubMenu.closest(".subMenu") : null;
        let previousSelectedAccordionMenu=null;
        
        // Added for colorView button id update in selectedConfig
        let iscolorViewButton = currentSelectedSubMenu ? currentSelectedSubMenu.classList.contains('colorView') : null;
        if(iscolorViewButton){
            window.selectedConfig[data.type] = data.id;
        }

        if(isradioButton){
          document.querySelector(`#menu_id_${data.id} input[type='radio']`).checked = true;
          let radioGroup = document.querySelectorAll(`input[name='${data.radioName}']`);
          
            window.selectedConfig[data.featureType] = data.id;
            
          radioGroup.forEach(radio => {
            let subMenuBtn = radio.closest(".subMenuBtn");
            if(subMenuBtn.classList.contains('active')) subMenuBtn.classList.remove('active');
          });

          document.querySelector(`#menu_id_${data.id}`).classList.add('active')

          /*Remove class of non radio submenu when changed radio option*/
          let nonRadioSubmenu = document.querySelectorAll('.subMenuBtn.active');
          let nonRadioSubmenuArray = [...nonRadioSubmenu];
          nonRadioSubmenuArray.forEach(submenu => {
            if(!submenu.classList.contains('radioButton') && !submenu.classList.contains('colorView')) {
              submenu.classList.remove('active');
              let selectedConfigKeys = Object.keys(window.selectedConfig);
              selectedConfigKeys.forEach(selectedConfigKey => {
                if(selectedConfigKey.includes('submenu_') && selectedConfigKey !== 'submenu_colorView'){
                  window.selectedConfig[selectedConfigKey] = "";
                }
              });
            }
          });
          /*Remove class of non radio submenu when changed radio option end*/
        } else {
          previousSelectedAccordionMenu = closestsubMenu ? closestsubMenu.querySelector('.subMenuBtn.active') : null;
          if(previousSelectedAccordionMenu) previousSelectedAccordionMenu.classList.remove('active');
          currentSelectedSubMenu.classList.add('active'); // to active the submenu, when we close accordion and open the accordion and click on same submenu
        }


        if(previousSelectedAccordionMenu && previousSelectedAccordionMenu.id !== data.id && currentSelectedSubMenu) currentSelectedSubMenu.classList.add('active');
        
        let isSubmenuAlreadySelectedForMobIpadPortrait = window.isMobIsipadIsPotrait && (window.selectedConfig['submenu_'+data.type] === window.selectedConfig['previous_submenu_'+data.type]) && window.selectedConfig['submenu_'+ data.type] != undefined;
        /*Show/Hide popup */
        
          let previousActivePopup = document.querySelector('.popup.active');
          if(previousActivePopup) previousActivePopup.classList.remove('active');
          let curruntActivePopup = document.getElementById(data.popupId);
          if(curruntActivePopup) curruntActivePopup.classList.add('active');
          if(isSubmenuAlreadySelectedForMobIpadPortrait){
                window.selectedConfig['previous_submenu_'+ data.type] = "";  // For Mobile and ipad Portrait submenu gets closed on same click with this line it makes isActive false in submenuList componenet
          } else {
             window.selectedConfig['previous_submenu_'+ data.type] = window.selectedConfig['submenu_'+data.type];
            
            
          }
          window.selectedConfig['submenu_'+data.type] = data.id;
          window.selectedConfig['currentSelectedSubmenu'] = data.id;
          window.selectedConfig['currentSelectedItem'] = data.id; // to keep track of current selected item in next previous functionality, this is required when we have multiple accordion and submenu and user has not selected any submenu from 2nd accordion and clicks next/previous then in that case it should select first submenu of that accordion 
          /* Update window.selectedConfig based on submenus updateSubmenuList */
            if(data.hasOwnProperty('updateSubmenuList') && Object.keys(data.updateSubmenuList).length > 0){
              let isAnyCondition = false;
              let conditionMatch = [];
              if(data.updateSubmenuList.hasOwnProperty('condition') && data.updateSubmenuList.condition !== "" &&  Object.keys(data.updateSubmenuList.condition).length !== 0){
                isAnyCondition = true;
                
                let conditionKeys = Object.keys(data.updateSubmenuList.condition);
                conditionKeys.forEach(conditionKey => {
                  
                  if(window.selectedConfig[conditionKey] && window.selectedConfig[conditionKey] === data.updateSubmenuList.condition[conditionKey]){
                    conditionMatch.push(true);
                  } else {
                    conditionMatch.push(false);
                  }
                });
              }
              if(!isAnyCondition ||  (isAnyCondition && conditionMatch.length > 0 && !conditionMatch.includes(false))){
                // Do something if no condition or condition does match
                let updateSubmenuListKeys = Object.keys(data.updateSubmenuList);
              
                updateSubmenuListKeys.forEach(property => {
                  window.selectedConfig[property] = data.updateSubmenuList[property];
                });
              }
              
              
            }
          /* Update window.selectedConfig based on submenus updateSubmenuList end */

        /*Make  accordion active or remove accordion active, used in next/previous functionality */
        let accordionID = `accordion_${data.type}`;
        let accordion = document.querySelector(`#${accordionID}`);
        let previousActiveAccordion = document.querySelector('.accordionMenu.active');

        if(previousActiveAccordion !== null && previousActiveAccordion.id !== accordionID) previousActiveAccordion.classList.remove('active');
        if(accordion !== null && !accordion.classList.contains('active')) {
          accordion.classList.add('active');
          manageAccordionContentHeight(accordionID, previousSelectedAccordionMenu !== null, accordion !== null, previousSelectedAccordionMenu);
        }
        /*Make  accordion active or remove accordion active, used in next/previous functionality end*/

        let hotspotData = null;
        //console.log('data ', data);
        if(data['content'] !== undefined && data['content'].length !== 0){
          hotspotData = data['content'].filter(filterMenuBasedOnConfigType)
        } else{
           window.clearCalloutCanvas();
        }
        // for dimension data @RT
        // let dimensionData = null;
        // if(data['dimensionData'] !== undefined && data['dimensionData'].length !== 0 && window.config.dimensions){
        //   dimensionData = data['dimensionData'];
        // } 
        window.resetRotationCenter(); // this function resets navigation rotation center to [0,0,0]


        if(window.shouldReRenderMenu) window.reRenderMenu(); // triggers re-render of menu component 

        window.UiUtils.handleUIwithMenuClick(data);
        if(hotspotData) window.UiUtils.handleHotspotwithMenuClick(hotspotData); // draw hotspot numbers on calloutcanvas
        /* Following code added to handle reset sequence on submenu click if already active submenu is clicked again */
        let isresetSequenceNameAvailable = data && data.hasOwnProperty("resetSequenceName") && data.resetSequenceName !== "" && typeof window[data.resetSequenceName] === "function";
        let isplayResetSequenceOnMenuReselect = data && data.hasOwnProperty("playResetSequenceOnMenuReselect") && data.playResetSequenceOnMenuReselect === true;
        let isSubMenuOrReset = resetHandler || (currentSelectedSubMenuAlreadyActive && isresetSequenceNameAvailable && isplayResetSequenceOnMenuReselect);
        /* Following code added to handle reset sequence on submenu click if already active submenu is clicked again end */
        
        window.UiUtils.handle3DwithMenuClick(data, !isSubMenuOrReset ? 'submenu' : 'reset');

        // if(dimensionData) window.UiUtils.handleDimensionsActivation(dimensionData); // this function activates/deactivates diamension based on current submenu

        setTimeout(function(){
          if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateTabindex('handleSubMenuClick',data.id, accordionID, nextPreviousHandler);          
        },100)
        setTimeout(function(){
          if(window.deviceBasedonBodyClass === 'desktop' || window.deviceBasedonBodyClass === 'ipadDesktopLandscape') window.UiUtils.updateAriaLabel('handleSubMenuClick',data, accordionID, nextPreviousHandler);
        },200)

        
        /*This line may cause regression as its big change, when we click on submenu we are making previous_submenu_positionView empty to aviod unwanted model jump */
        if(data.type !== 'positionView' && window.selectedConfig.hasOwnProperty("submenu_positionView")){
          setTimeout(function(){
            window.selectedConfig['submenu_positionView'] = ""; 
          }, 500)
        }
        /*This line may cause regression as its big change, when we click on submenu we are making previous_submenu_positionView empty to aviod unwanted model jump */
        
        // console.log('handleSubMenuClick called..... data.hasOwnProperty(updateAccordionVisibility) ', data.hasOwnProperty('updateAccordionVisibility'))
        // console.log('handleSubMenuClick called..... data.updateAccordionVisibility.length ', data.updateAccordionVisibility.length > 0)
        if(data.hasOwnProperty('updateAccordionVisibility') && data.updateAccordionVisibility.length > 0 ) {
          setIsFirstAccordion(true);
          
          // console.log('handleSubMenuClick called..... updateActiveAccordionMobile ', data.updateActiveAccordionMobile)
          // onLoadActiveAccordionMobile(data.updateActiveAccordionMobile);
        } else {
          setIsFirstAccordion(false);
        }
           
         // @DS called function to recalculate the accordion height whenever a submenu is shown or hidden.
        setTimeout(() => {
            window.UiUtils.updateAccordionHeight()
        }, 0);
      

      }
    /*MENU END */

    /*Code to check configType of main accordion and show/hide the menu based on configType if any*/
    const filterMenuBasedOnConfigType = (list => {
        
        let isConfigTypeAvailable = list.hasOwnProperty("configType");
        let showaccordion = false;
        let showaccordionArray = [];
        if(isConfigTypeAvailable) {
        let listConfigType = Object.keys(list.configType);
       // console.log('list.configType ', list.configType)
        // if(list.configType.colorView === 'apolloPlastic'){
        //   debugger;
        // }
        listConfigType.forEach(configTypeText => {

          // console.log('window.selectedConfig[configTypeText].toLowerCase() ', window.selectedConfig[configTypeText].toLowerCase());
          // console.log('window.selectedConfig[configTypeText].toLowerCase() ', window.selectedConfig[configTypeText].toLowerCase());

          if(typeof list.configType[configTypeText] === 'string'){
            if(list.configType[configTypeText] && window.selectedConfig[configTypeText] && list.configType[configTypeText].toLowerCase() == window.selectedConfig[configTypeText].toLowerCase()){
                showaccordionArray.push('true');
            } else {
                showaccordionArray.push('false');
            }
          } else if(Array.isArray(list.configType[configTypeText])){
              let isAnyMatch = []
              list.configType[configTypeText].forEach(configTypeValue => {
                  if(configTypeValue && window.selectedConfig[configTypeText] && configTypeValue.toLowerCase() == window.selectedConfig[configTypeText].toLowerCase()){
                      isAnyMatch.push('true');
                  } else {
                      isAnyMatch.push('false');
                  }
              });
              if(isAnyMatch.includes('true')){
                  showaccordionArray.push('true');
              } else {
                  showaccordionArray.push('false');
              }
          }
        });
        } else {
            showaccordionArray.push('true');
        }
        if(showaccordionArray.includes('false')){
            showaccordion = false;
        } else {
            showaccordion = true;
        }
        return showaccordion;
        
    });
    /*Code to check configType of main accordion and show/hide the menu based on configType if any end*/

    /*calculate HTMl element actul width without wrap */
    const calcHtmlElementNoWrapWidth = (text, fontSize) => {
      let dummyEle = document.createElement('p');
      dummyEle.id = 'dummyEle';
      dummyEle.classList.add('dummyEle');
      dummyEle.style.width = 'max-content';
      dummyEle.style.fontSize = parseInt(fontSize)+'px';
      dummyEle.innerText = text;
      
      document.body.append(dummyEle);
      let maxWidth = dummyEle.offsetWidth;
      dummyEle.remove();
      return maxWidth;

    }
    /*calculate HTMl element actul width without wrap end */

    /*Footer Controls */
    const onPreviousMode = () => {
      nextPreviousHandler('previous');
      // window.UiUtils.handleUIwithMenuClick(); //@YK commented as we have called handleSubMenuClick in nextPreviousHandler so this function gets called 2 times so commented
    }
    const onNextMode = () => {
       window.resetRotationCenter(); // this function resets navigation rotation center to [0,0,0]
      
      /*
      let currentSelectedSubmenu = window.selectedConfig.currentSelectedSubmenu;
      let nextPrevArray = [...window.config.nextPrevArray];
      console.log('Next currentSelectedSubmenu.... ', currentSelectedSubmenu);
      console.log('Next clicked.... ', nextPrevArray);

      let currentSelectedSubMenuIndex = nextPrevArray.findIndex(menuList => {
        return menuList.id === currentSelectedSubmenu;
      });

      console.log('Next clicked.... nextPrevArray', nextPrevArray.length-1);
      console.log('Next clicked.... currentSelectedSubMenuIndex', currentSelectedSubMenuIndex);
      if(currentSelectedSubMenuIndex === nextPrevArray.length-1) currentSelectedSubMenuIndex = -1; 
      let nextElement = nextPrevArray[currentSelectedSubMenuIndex+1];
      let nextElementID = nextElement.id; 
      */
      nextPreviousHandler('next');


      // let accordionID = 'accordion_'+nextElement.type;
      // let accordionID = `accordion_${nextElement.type}`;
      // let accordion = document.querySelector(`#${accordionID}`);
      // console.log('nextElement ', accordionID);
      // if(!accordion.classList.contains('active')) accordion.classList.add('active');
      // window.UiUtils.handleUIwithMenuClick(); //@YK commented as we have called handleSubMenuClick in nextPreviousHandler so this function gets called 2 times so commented
    }

    const onReset = () => {
      window.resetRotationCenter(); // this function resets navigation rotation center to [0,0,0]
      let currentSelectedSubmenu = window.selectedConfig.currentSelectedSubmenu;
      let currentSelectedItem = window.selectedConfig.currentSelectedItem; // to keep track of current selected item in next previous functionality, this is required when we have multiple accordion and submenu and user has not selected any submenu from 2nd accordion and clicks next/previous then in that case it should select first submenu of that accordion
      if(!currentSelectedItem === undefined && (currentSelectedItem === "" || currentSelectedItem === null) ) currentSelectedItem = currentSelectedSubmenu; 
      //console.log('Reset currentSelectedItem.... ', currentSelectedItem);
      let allMenu = [...window.config.allMenu];
      let currentSelectedSubMenuObj= allMenu.filter(menuList => {
       // console.log(' allMenu ', allMenu)
        //console.log(' currentSelectedItem ', currentSelectedItem)
          return menuList.id === currentSelectedItem;
        });
        console.log('currentSelectedSubMenuObj ', currentSelectedSubMenuObj)
        currentSelectedSubMenuObj = currentSelectedSubMenuObj[0];
        // console.log('currentSelectedSubMenuObj ', currentSelectedSubMenuObj)
        
        // if(currentSelectedSubMenuObj === undefined) currentSelectedSubMenuObj = 'Normal_Reset'
        // let isresetSequenceNameAvailable = currentSelectedSubMenuObj && currentSelectedSubMenuObj.hasOwnProperty("resetSequenceName") && currentSelectedSubMenuObj.resetSequenceName !== "" && typeof window[currentSelectedSubMenuObj.resetSequenceName] === "function";
      window.UiUtils.handleUIwithMenuClick();
      window.UiUtils.handle3DwithMenuClick(currentSelectedSubMenuObj, 'reset');
      
      
      if(currentSelectedSubMenuObj !== undefined && currentSelectedSubMenuObj.items && currentSelectedSubMenuObj.items.length > 0) {
        accordionMenu(currentSelectedSubMenuObj, `accordion_${currentSelectedSubMenuObj.id}`, 'reset');
      } else {
        console.log('currentSelectedSubMenuObj ', currentSelectedSubMenuObj)
        console.log('currentSelectedItem ', currentSelectedItem)
        if(currentSelectedItem) handleSubMenuClick(currentSelectedSubMenuObj,currentSelectedItem, true, true); //removed .type !== 'colorView' condition as updated resetSequenceName in data.json for submenu

      }
    }

    const nextPreviousHandler = (mode) => {
         window.resetRotationCenter(); // this function resets navigation rotation center to [0,0,0]
      // if(mode === 'next') {
        let currentSelectedSubmenu = window.selectedConfig.currentSelectedSubmenu;
        let nextPrevArray = [...window.config.nextPrevArray];
        let currentSelectedItem = window.selectedConfig.currentSelectedItem; // to keep track of current selected item in next previous functionality, this is required when we have multiple accordion and submenu and user has not selected any submenu from 2nd accordion and clicks next/previous then in that case it should select first submenu of that accordion
        if(!currentSelectedItem === undefined && (currentSelectedItem === "" || currentSelectedItem === null) ) currentSelectedItem = currentSelectedSubmenu; 

        let currentSelectedItemIndex = nextPrevArray.findIndex(menuList => {
          return menuList.id === currentSelectedItem;
        });

        if(mode === 'next') {
          if(currentSelectedItemIndex === nextPrevArray.length-1) currentSelectedItemIndex = -1; 
        } else if(mode === 'previous'){
          if(currentSelectedItemIndex === 0 || currentSelectedItemIndex === -1) currentSelectedItemIndex = nextPrevArray.length; 
        }

        let nextElement = mode === 'next' ? nextPrevArray[currentSelectedItemIndex + 1] : nextPrevArray[currentSelectedItemIndex - 1];
        let nextElementID = nextElement.id;

        /*
        1. if accordion has sequence it should get include in Next Previous Array, if next element is Accordion then expand accordion 
        */

        if(nextElement.items && nextElement.items.length > 0) { // Added this if block to handle accordion in next previous
          //console.log('nextElement is accordion ');
          accordionMenu(nextElement, `accordion_${nextElementID}`);
        } else {
          handleSubMenuClick(nextElement,nextElementID, true);
      }

      window.selectedConfig.currentSelectedItem = nextElementID;
      // }
    }
    /*Footer Controls End */

   

  return (
    <>
      <div className='leftMenuWrapper' id='leftMenuWrapper'>
        {(!window.isDesktop && QRSupport) && <Arbutton ui={ui} calcHtmlElementNoWrapWidth={calcHtmlElementNoWrapWidth} ></Arbutton>}
        <HowToUse count={count} ui={ui} QRSupport={QRSupport}></HowToUse>
        <GlobalDisclaimer ui={ui} />
        {<Menu count={count} isFirstAccordion={isFirstAccordion} ui={ui} QRSupport={QRSupport} menuSubmenu={menuSubmenu} onLoadActiveradioButton={onLoadActiveradioButton} onLoadActiveAccordionMobile={onLoadActiveAccordionMobile} accordionMenuclick={accordionMenu} handleSubMenuClick={handleSubMenuClick} filterMenuBasedOnConfigType={filterMenuBasedOnConfigType} calcHtmlElementNoWrapWidth={calcHtmlElementNoWrapWidth} cssVariableValues={cssVariableValues}></Menu>}
        
      </div>
      
      {(!window.isMobIsipadIsPotrait) && <FooterControl count={count} ui={ui} onNext={onNextMode} onPrevious={onPreviousMode} onReset={onReset}></FooterControl>}
      
    </>
  );
}

export default App;